import { defineNuxtRouteMiddleware, setPageLayout } from '#app'
import { getAppContext } from '@b2ag/micro-front-tools'

export default defineNuxtRouteMiddleware((to) => {
  setPageLayout(to.meta?.layout || getAppContext().appFrontType)
})
